import LinearProgress from "@mui/material/LinearProgress";
import { progressBarStyle } from "./ProgressBar.style";

interface ProgressBarProps {
  progress: number;
}
function ProgressBar(props: ProgressBarProps) {
  const { progress } = props;

  return (
    <LinearProgress
      sx={progressBarStyle}
      variant="determinate"
      value={progress}
    />
  );
}

export default ProgressBar;
